export const DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';

// regex for hh:mm:ss or h:mm:ss
export const TIME_REGEX = /(?:[01]\d|2[0123]):(?:[012345]\d):(?:[012345]\d)/;

export const DEFAULT_START_TIME = '00:00:00';
export const DEFAULT_END_TIME = '23:59:00';
export const DEFAULT_END_ANY_TIME = '23:59:59';

export const DEFAULT_SCHEDULE = {
  everyday: {
    isOn: true,
    timeSlots: [
      { startTime: DEFAULT_START_TIME, endTime: DEFAULT_END_ANY_TIME },
    ],
  },
};

export const errorMessages = {
  everyDayError: `Everyday - start time should be before end time`,
  emptyScheduleError: `Schedule cannot be empty`,
  invalidTimeError: `Invalid time`,
  invalidTimeIntervalError: `Invalid time slot`,
  alreadyExists: `Time slot is already selected`,
  timeOverlapError: `Time slots overlap - please make the proper changes and submit again`,
};

export const DAYS = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
];
